<template>
  <v-card>
    <v-toolbar card dense dark color="primary">
      <v-toolbar-title class="white--text">Descartar cambios</v-toolbar-title>
    </v-toolbar>
    <v-card-actions class="justify-center">¿Desea descartar los cambios y volver?</v-card-actions>
    <v-card-actions>
      <v-btn block flat class="secondary" @click="cerrar">No</v-btn>
      <v-btn block flat class="primary" @click="aceptar">Si</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "CancelarModal",
  data() {
    return {};
  },
  methods: {
    aceptar() {
      this.$emit("cerrar");
      this.$router.push("/");
    },
    cerrar() {
      this.$emit("cerrar");
    }
  }
};
</script>
